// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__3bdRf","label":"Cell_label__3lTEr","name":"Cell_name__2qb1M","root":"Cell_root__2Dk1b","fadeIn":"Cell_fadeIn__3LfvI","fadeOut":"Cell_fadeOut__Rf0eD"};